import { render, staticRenderFns } from "./reviews.vue?vue&type=template&id=5f3bd825&scoped=true&"
import script from "./reviews.vue?vue&type=script&lang=js&"
export * from "./reviews.vue?vue&type=script&lang=js&"
import style0 from "./reviews.vue?vue&type=style&index=0&id=5f3bd825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3bd825",
  null
  
)

export default component.exports